import { observer } from 'mobx-react-lite'
import { CardsFilter } from 'shared/ui'
import { useHubspotWorkflowViewContext } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/context/context'
import styles from './styles.module.scss'

export const HubspotWorkflowStatisticsFilter = observer(() => {
  const { filters, onActiveFilter, filter } = useHubspotWorkflowViewContext()

  if (!filters) return null

  return (
    <>
      <CardsFilter
        items={filters}
        activeKey={filter}
        onActiveFilter={onActiveFilter}
        wrapperClassName={styles.filterWrapper}
      />
      <div className={styles.separator} />
    </>
  )
})
